export const message = {
  saveFormStatusSuccessMessage: 'Workflow successfully saved',
  publishFormStatusSuccessMessage: 'Workflow successfully published'
}